export { CollectionA } from './CollectionA';